
import { Component, Prop, VModel, Vue } from "vue-property-decorator";
import CartContent from "@/components/item-market/CartContent.vue";
import { UserItemEntity } from "@/entities/user-item.entity";

@Component({
  components: {
    CartContent,
  },
})
export default class CartDialog extends Vue {
  @VModel({ type: Boolean }) show!: boolean;
  @Prop() items!: UserItemEntity[];
  @Prop() attach!: string;
}
